import type { ComponentProps } from "react";
import { motion } from "motion/react";

export const Collapse = (props: ComponentProps<typeof motion.div>) => {
  return (
    <motion.div
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: "auto" }}
      exit={{ opacity: 0, height: 0 }}
      transition={{ duration: 0.2 }}
      className="overflow-hidden"
      {...props}
    />
  );
};
